import React from 'react';
import { Layout } from 'antd'; 
import {SYSTEMNAME} from '../appsettings';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const { Footer } = Layout;

const Footerdiv = () => {
    
    return (
      <>
        <Footer
          style={{
            textAlign: 'center',
            backgroundColor:'#52c9eeff'
          }}
        >
          {SYSTEMNAME} ©{new Date().getFullYear()} Developed by <a style={{color:"#fff"}} href="https://dsoftmedia.com">DSM IT (PVT) LTD</a>
        </Footer>
        <ToastContainer />
      </>
    );
  };
  export default Footerdiv;